module.exports = __webpack_public_path__ + "img/11_82.ba05659b.png";